import React from "react";

import { useBreakpoint } from "../../../hooks";
import { useContentColor } from "../../../styles/colors/content/useContentColor";
import { ContentEmphasis, KeyColorRole } from "../../../styles/colors/types";
import {
  headingLineHeightMap,
  TypographyHeadingLevel,
  typographyHeadingLevelMap,
  typographyHeadingLevelMobileAndTabletMap,
  TypographyLineHeight
} from "../../../styles/typography/typography";
import { Box } from "../../layout";
import { truncateStyles, uppercaseStyles } from "../consts";

import type { FontWeight, ResponsiveProp, TextAlign } from "../../../types";
type Props = {
  children: React.ReactNode | string;
  level: TypographyHeadingLevel;
  tone?: KeyColorRole;
  emphasis?: ContentEmphasis;
  onHighEmphasisSurface?: boolean;
  lineHeight?: TypographyLineHeight;
  weight?: FontWeight;
  align?: ResponsiveProp<TextAlign>;
  uppercase?: boolean;
  dataNoTranslate?: boolean;
  truncate?: boolean;
};

export default function Heading({
  children,
  level,
  tone = "neutral",
  emphasis = "high",
  onHighEmphasisSurface = false,
  lineHeight = "large",
  weight = "bold",
  dataNoTranslate,
  align,
  uppercase = false,
  truncate = false
}: Props) {
  const color = useContentColor({ tone, emphasis, onHighEmphasisSurface });

  const { isMobileOrTablet } = useBreakpoint();

  const elementAndFontSize =
    isMobileOrTablet && level === "1"
      ? typographyHeadingLevelMobileAndTabletMap[level]
      : typographyHeadingLevelMap[level];

  return (
    <Box
      {...elementAndFontSize}
      {...headingLineHeightMap[lineHeight]}
      fontWeight={weight}
      textAlign={align}
      margin="none"
      padding="none"
      dataNoTranslate={dataNoTranslate}
      color={color}
      {...(uppercase && uppercaseStyles)}
      {...(truncate && truncateStyles)}
    >
      {children}
    </Box>
  );
}
